// extracted by mini-css-extract-plugin
module.exports = {"wd4xu42":"wd4xu42","rmuzhn5":"rmuzhn5","l1agd0o7":"l1agd0o7","vprx4z3":"vprx4z3"};